const InsuredData = ({
  Name,
  BIDType,
  Document,
  DocumentNumber,
  PolicyHolder,
}) => ({
  name: Name ?? '',
  BIDType: BIDType ?? '',
  document: Document ?? '',
  documentNumber: DocumentNumber ?? '',
  policyHolder: PolicyHolder ?? '',
})

export default InsuredData
